import update from '../update';

import {
  START_TIMER,
  ADD_TO_TOTAL_SESSION_DURATION,
} from './constants';

const initialState = {
  startTime: new Date(),
  totalSessionDuration: 0, // MILLISECONDS! We calculate seconds at the end
};

const mixpanelReducer = (state=initialState, action) => {
  switch (action.type) {

    case START_TIMER:
      return {
        ...state,
        startTime: action.payload || new Date().getTime()
      };

    case ADD_TO_TOTAL_SESSION_DURATION:
      return update(state, {
        totalSessionDuration: {$set: state.totalSessionDuration + action.payload}
      });

    default:
      return state;
  }
}

export default mixpanelReducer;



// WEBPACK FOOTER //
// ./src/redux/mixpanel/reducer.js